<script setup lang="ts">
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import { READING_DARK_MODE_BOOT_SCRIPT } from '~/utils/reading-routes'

const previewMode = usePreviewMode()

const config = useRuntimeConfig()

const site = useSiteConfig()

useHead({
  script: previewMode.enabled.value
    ? [
        {
          src: 'https://app.crystallize.com/static/frontend-preview-listener.js',
          defer: true,
        },
      ]
    : [],
  link: [
    {
      rel: 'icon',
      type: 'image/png',
      href: `${config.app.cdnURL || '/'}favicon.png?t=${Date.now()}`,
    },
  ],
  htmlAttrs: {
    prefix: 'og: https://ogp.me/ns#',
    lang: computed(() => site.defaultLocale),
  },
})

if (import.meta.server) {
  useHead({
    script: [
      {
        key: 'reading-dark-mode',
        tagPriority: 'critical',
        innerHTML: READING_DARK_MODE_BOOT_SCRIPT,
      },
    ],
  })
}

usePendoEnrichment()
</script>

<template>
  <NuxtRouteAnnouncer />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <ClientOnly>
    <VueQueryDevtools />
  </ClientOnly>
</template>
